import { Card, Stack } from '@mantine/core'
import { AlertsFilters } from 'components/alerts/AlertsFilters'
import { AlertsListTable } from 'components/alerts/AlertsTable'
import { useParams } from 'react-router-dom'

export const DeviceAlerts = () => {
  const deviceId = useParams().deviceId as string
  return (
    <Card>
      <Stack>
        <AlertsFilters noWrapper excludeDevice />
        <AlertsListTable params={{ deviceId }} />
      </Stack>
    </Card>
  )
}
